export const CONTENT_SECTIONS = [
  { group: "General", items: [
    { key: "SITE", label: "Contact details", hint: "Emails, WhatsApp number and location shown across the site." },
    { key: "NAV_LINKS", label: "Navigation menu", hint: "Labels only — the id must match a section on the page (home, services, divisions, academy, about, contact)." },
    { key: "HERO", label: "Home hero", hint: "Headline lines, intro paragraph, buttons and floating badges." },
    { key: "MARQUEE_ITEMS", label: "Scrolling ticker", hint: "Uppercase phrases in the moving strip below the hero." },
    { key: "TRUST_ROW", label: "Trust row", hint: "Four promise cards. Icon names come from lucide.dev (e.g. Globe2, Users)." },
    { key: "STATS", label: "Numbers band", hint: "Animated counters on the dark strip." },
  ]},
  { group: "Services", items: [
    { key: "CAPABILITIES", label: "What we do", hint: "Service groups and the items under each." },
    { key: "ADMIN_PANEL_HIGHLIGHT", label: "Admin panel highlight", hint: "The gold card promoting the included admin panel." },
    { key: "INDUSTRIES", label: "Industries we serve", hint: "Chip list of sectors." },
    { key: "PROCESS", label: "How we work", hint: "Four process steps." },
    { key: "TESTIMONIALS", label: "Client testimonials", hint: "Rotating quotes — replace with real client feedback." },
  ]},
  { group: "Divisions & Academy", items: [
    { key: "DIVISIONS", label: "Divisions", hint: "Status text, active (live) flag and the notify flag for Academy." },
    { key: "ACADEMY", label: "Academy section", hint: "Waitlist headline, perks and the interest options." },
    { key: "COURSES", label: "Course preview cards", hint: "Icons: Braces, ShieldAlert, Database (or any lucide icon name)." },
  ]},
  { group: "About & FAQ", items: [
    { key: "COMPANY_COPY", label: "Company paragraphs" },
    { key: "FOUNDER", label: "Founder card" },
    { key: "FAQ", label: "FAQ" },
    { key: "ENQUIRY_TOPICS", label: "Contact form topics", hint: "Options in the 'What do you need?' dropdown." },
  ]},
  { group: "Legal", items: [
    { key: "PRIVACY_POLICY", label: "Privacy Policy" },
    { key: "TERMS_OF_SERVICE", label: "Terms of Service" },
  ]},
];
